export const warningCircle = [
  '0 0 28 28',
  `<path d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z" stroke="#495057" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 8.75V14.875" stroke="#495057" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 19.25C14.4832 19.25 14.875 18.8582 14.875 18.375C14.875 17.8918 14.4832 17.5 14 17.5C13.5168 17.5 13.125 17.8918 13.125 18.375C13.125 18.8582 13.5168 19.25 14 19.25Z" fill="#495057"/>`,
]
